<div class="container-chat">
  <div class="subtitle">
    <span>Nova Negociação</span>
  </div>

  <div class="modal-backdrop" (click)="onCancel()"></div>
  <div class="modal-container">
    <div class="modal">
      <div class="modal-header">
        <h3 class="modal-title">Nova Negociação</h3>
      </div>

      <div class="modal-body card">
        <form [formGroup]="negotiationForm" (ngSubmit)="onSubmit()">
          <mat-form-field appearance="outline" floatLabel="always" class="mb-md">
            <mat-label>Mensagem Inicial</mat-label>
            <textarea matInput formControlName="initialMessage" placeholder="Digite uma mensagem inicial para a negociação" rows="5" maxlength="500"></textarea>
            <mat-hint align="start" class="text-secondary">Seja claro e objetivo. Evite informações sensíveis.</mat-hint>
            <mat-hint align="end">{{ negotiationForm.get('initialMessage')?.value?.length || 0 }}/500</mat-hint>
            <mat-error *ngIf="negotiationForm.get('initialMessage')?.invalid && negotiationForm.get('initialMessage')?.touched">
              {{ getErrorMessage('initialMessage') }}
            </mat-error>
          </mat-form-field>
        </form>
      </div>

      <div class="modal-footer">
        <button class="btn btn-ghost" type="button" (click)="onCancel()" [disabled]="isLoading">Cancelar</button>
        <button class="btn btn-primary" type="submit" (click)="onSubmit()" [disabled]="negotiationForm.invalid || isLoading">
          @if(isLoading) { <span>Processando...</span> } @else { <span>Criar Negociação</span> }
        </button>
      </div>
    </div>
  </div>
</div>